import type { ReactNode } from 'react';

export const symbol_room_service: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-200q-13 0-21.5-8.5T80-230q0-13 8.5-21.5T110-260h740q13 0 21.5 8.5T880-230q0 13-8.5 21.5T850-200H110Zm0-120v-17q0-155 88.5-250T420-710v-30q0-26 17-43t43-17q26 0 43 17t17 43v30q133 28 221.5 123T850-337v17H110Zm63-60h614q-14-128-102.5-200.5T479-653q-117 0-204.5 72.5T173-380Zm307 0Z"
		/>
	</svg>
);
